import React from 'react';

export const PageShell = ({ children }) => (
  <div className="relative flex flex-1 flex-col">{children}</div>
);

export const BorderedPanel = ({ children }) => (
  <div className="m-auto flex w-full max-w-md flex-col items-center gap-6 rounded-md border border-gray-200 bg-white p-6 text-center shadow-sm">
    {children}
  </div>
);
